module.exports = __webpack_public_path__ + "static/media/logo_vietcapital.bc530924.svg";